module.exports = __webpack_public_path__ + "static/closeup-093375f32af39c7f4882fc6814cf3cde.jpg";